import { Button, Grid, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { useRedirect } from "react-admin";
import dataProvider from "../../../providers/data-provider";

const QuizStats = (props) => {

    const redirect = useRedirect()

    const [loading, setLoading] = useState(true)
    const [stats, setStats] = useState(null)

    useEffect(() => {
        dataProvider.get('users', 'quiz-stats')
            .then((res) => { setStats(res.data); setLoading(false) })
    }, [])

    return (
        <Grid container item direction="column" style={{ paddingInline: '16px', paddingBlock: '32px' }}>
            <Typography variant="h4" style={{ marginBottom: '16px' }}>Estatísticas</Typography>
            <Grid container item>
                <Typography variant="body1" style={{ marginRight: '16px' }}>{`Avaliações realizadas:`} </Typography>
                <Typography variant="body1" style={{ width: '20px' }}>{loading ? <Skeleton /> : `${stats.total_quizzes}`}</Typography>
            </Grid>
            <Grid container item>
                <Typography variant="body1" style={{ marginRight: '16px' }}>{`Questões resolvidas:`} </Typography>
                <Typography variant="body1" style={{ width: '20px' }}>{loading ? <Skeleton /> : `${stats.total_questions}`}</Typography>
            </Grid>
            <Grid container item>
                <Typography variant="body1" style={{ marginRight: '16px' }}>{`Quantidade de acertos:`} </Typography>
                <Typography variant="body1" style={{ width: '20px' }}>{loading ? <Skeleton /> : `${stats.correct_questions}`}</Typography>
            </Grid>
            <Grid container item>
                <Typography variant="body1" style={{ marginRight: '16px' }}>{`Taxa de acertos:`}</Typography>
                <Typography variant="body1" style={{ width: '20px' }}>{loading ? <Skeleton /> : stats.total_questions > 0 ? `${(100 * (stats.correct_questions / stats.total_questions)).toFixed(2)}%` : '-'}</Typography>
            </Grid>

            <Button style={{ width: '150px', marginTop: '32px' }} onClick={() => redirect('/quiz')} variant="contained" color="primary">Novo Quiz</Button>
        </Grid>
    )
}

export default QuizStats;